<div class="asset-routine-container flex-column d-flex">
  <div class="header mb-4">
    <div>
      <a class="d-inline-block"
        [routerLink]="['/asset-management/compliance-overview']" [queryParams]="{ tab: 'routineComplianceTasks' }">
				<h2 class="d-flex align-items-center gap-2 m-0 h3">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
						<path
							d="M20.9999 11H6.41394L11.7069 5.70697L10.2929 4.29297L2.58594 12L10.2929 19.707L11.7069 18.293L6.41394 13H20.9999V11Z"
							fill="#9FA1A4" />
					</svg>
          <span class="title m-0">{{ assetName }}</span>
				</h2>
			</a>
    </div>
  </div>

  <div class="row mb-4">
    @if (assetId && complianceId) {
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-pass-widget [assetId]="assetId" [complianceId]="complianceId" [taskId]="routineComplianceTaskId" source="routine"></app-pass-widget>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-fail-widget [assetId]="assetId" [complianceId]="complianceId" [taskId]="routineComplianceTaskId" source="routine"></app-fail-widget>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-pending-widget [assetId]="assetId" [complianceId]="complianceId" [taskId]="routineComplianceTaskId" source="routine"></app-pending-widget>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-inspection-pass-rate-widget [assetId]="assetId" [complianceId]="complianceId" [taskId]="routineComplianceTaskId" source="routine"></app-inspection-pass-rate-widget>
      </div>
    }
  </div>

  @if (showPreTab && showPostTab) {
    <div class="cmn_tabWrap">
      <div class="cmn_tabWrapUl">
        <ul class="nav nav-pills" id="pills-tab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link" [class.active]="activeTab === 'pre'"
              type="button" role="tab" [attr.aria-selected]="activeTab === 'pre'"
              (click)="toggleTab('pre')">
              {{ preTabTitle }}
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" [class.active]="activeTab === 'post'"
              type="button" role="tab" [attr.aria-selected]="activeTab === 'post'"
              (click)="toggleTab('post')">
              {{ postTabTitle }}
            </button>
          </li>
        </ul>
      </div>
    </div>
  }

  <div>
		<div class="col-12">
  		@switch(activeTab) {
    		@case('pre') {
          @if (showPreTab) {
            <app-pre-routine-type-checklist
              [assetName]="assetName"
              [assetId]="assetId"
              [complianceId]="complianceId"
              [routineTypeId]="routineTypeId"
              [inspectionTypeId]="preInspectionTypeId"
              [routineComplianceTaskId]="routineComplianceTaskId"
              [routineChecklistTypeLabel]="routineChecklistTypeLabel"
              [videos]="preVideos"
              [videosLoading]="isVideosLoading"
              [details]="preDetails"
              [isLoading]="isLoading"
              [hasError]="hasError">
            </app-pre-routine-type-checklist>
          }
    		}
    		@case('post') {
          @if (showPostTab) {
            <app-post-routine-type-checklist
              [assetName]="assetName"
              [assetId]="assetId"
              [complianceId]="complianceId"
              [routineTypeId]="routineTypeId"
              [inspectionTypeId]="postInspectionTypeId"
              [routineComplianceTaskId]="routineComplianceTaskId"
              [routineChecklistTypeLabel]="routineChecklistTypeLabel"
              [videos]="postVideos"
              [videosLoading]="isVideosLoading"
              [details]="postDetails"
              [isLoading]="isLoading"
              [hasError]="hasError">
            </app-post-routine-type-checklist>
          }
    		}
  		}
		</div>
	</div>
</div>